import React, { useState, useEffect } from 'react';

import { Form, Button } from 'react-bootstrap';
import Navigator from 'Components/Shared/Navigator';
import { useHistory } from 'react-router-dom';
// import { useForm } from 'react-hook-form';

import EventService from 'Services/EventService';

import * as yup from 'yup';
import { Formik } from 'formik';

const schema = yup.object({
    handle: yup.string().min(3).required(),
    description: yup.string().min(3).required(),
    notifyOriginSupervisor: yup.boolean(),
});

const EventsCreateOrEdit = (props) => {
    const history = useHistory();
    const [event, setEvent] = useState(null);
    // const { register, handleSubmit, errors } = useForm();

    const {
        match: { params },
    } = props;

    useEffect(() => {
        if (params.eventId) {
            EventService.getEventById(params.eventId)
                .then((result) => {
                    if (result.status === 200) {
                        setEvent(result.data);
                        console.log(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const submitForm = (data) => {
        EventService.saveEvent(data, params.eventId)
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/event/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };
    return (
        <>
            <Navigator section="Events" sectionUrl="event/index" action="Create New Event"></Navigator>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">{params.eventId ? 'Edit Event' : 'Create New Event'}</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.eventId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values) => submitForm(values)}
                        enableReinitialize={true}
                        initialValues={{
                            handle: event ? event.handle : '',
                            description: event ? event.description : '',
                            notifyOriginSupervisor: event ? event.notifyOriginSupervisor : false,
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group controlId="formBasic1">
                                    <Form.Label>Handle</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Handle"
                                        name="handle"
                                        value={values.handle}
                                        onChange={handleChange}
                                        isInvalid={!!errors.handle}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.handle}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasic2">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Description"
                                        name="description"
                                        value={values.description}
                                        onChange={handleChange}
                                        isInvalid={!!errors.description}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicCheckbox">
                                    <Form.Check
                                        type="checkbox"
                                        label="Notify Supervisor"
                                        name="notifyOriginSupervisor"
                                        checked={values.notifyOriginSupervisor}
                                        onChange={handleChange}
                                        isInvalid={!!errors.notifyOriginSupervisor}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.notifyOriginSupervisor}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Button variant="primary" type="submit" block>
                                    Submit
                                </Button>
                            </Form>
                        )}
                    </Formik>
                    {/* {errors.exampleRequired && <span>This field is required</span>}

                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Handle</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Handle"
                                name="Handle"
                                defaultValue={event ? event.handle : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Description"
                                name="Description"
                                defaultValue={event ? event.description : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBasicCheckbox">
                            <Form.Check
                                type="checkbox"
                                label="NotifyOriginSupervisor"
                                name="NotifyOriginSupervisor"
                                checked={event ? event.notifyOriginSupervisor : false}
                                ref={register}
                                onChange={console.log('changed')}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" block>
                            Submit
                        </Button>
                    </Form> */}
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default EventsCreateOrEdit;
